import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { isProd } from './util/config';

// These are so small it's not worth the network overhead to import them dynamically
// If we add more keys or support more languages, it might be worth splitting them out
import englishTranslation from './locales/en/translation.json';
import spanishTranslation from './locales/es/translation.json';

const map = {
  en: englishTranslation,
  es: spanishTranslation,
};

i18next
  .use(resourcesToBackend((language, namespace, callback) => {
    callback(null, map[language]);
  }))
  .init({
    fallbackLng: 'en',
    debug: !isProd,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18next;
